<template>
  <div v-if="$canAndRulesPass(user, $permissions.USER.CHIEFS_LIST_BY_TYPE)">
    <page-heading :heading="pageTitle">
      <span slot="help"></span>
      <span slot="right"></span>
    </page-heading>
    <el-card
      v-for="chiefType in $companyConfiguration.user.getChiefTypes()"
      :key="chiefType"
      style="margin-bottom: 25px"
    >
      <chiefs-edit-component
        :type="chiefType"
        :reload-trigger="reloadTriggers[chiefType] || 0"
      >
        <template v-slot:extra-actions>
          <import-modal
            entity="chiefs_import"
            title="Импорт подчинённости"
            :data="{type: chiefType}"
            close-on-success
            @import-finished="onImportFinished(chiefType)"
          >
            <template v-slot:reference>
              <el-button
                size="mini"
                icon="fas fa-file-import"
              >
                Импорт
              </el-button>
            </template>
          </import-modal>
        </template>
      </chiefs-edit-component>
    </el-card>
  </div>
</template>

<script>
import PageHeading from "@/components/PageHeading";
import ChiefsEditComponent from "@/components/user/ChiefsEditComponent.vue";
import ImportModal from "@/components/exportImport/ImportModal.vue";
import {mapGetters} from "vuex";

export default {
  name: 'SmzChiefs',
  components: {ChiefsEditComponent, PageHeading, ImportModal},
  computed: {
    ...mapGetters(['user']),
    pageTitle() {
      return document.title;
    },
  },
  data() {
    return {
      reloadTriggers: {},
    };
  },
  methods: {
    onImportFinished(chiefType) {
      this.$set(this.reloadTriggers, chiefType, (this.reloadTriggers[chiefType] || 0) + 1);
    },
  },
};
</script>
